









import Vue from 'vue';
import { openModal } from 'mycorems-app-shared';
import { User } from '../types';
import { isServiceRoleMode } from '../config';
import UserRolesModal from './UserRolesModal.vue';

export default Vue.extend({
  props: {
    user: {
      type: Object as () => User,
      required: true,
    },
  },
  computed: {
    label(): string {
      if (isServiceRoleMode()) {
        return `${this.user.roles.length}`;
      }
      if (this.user.roles.length === 0) {
        return 'None';
      }
      return this.user.roles[0].role.name;
    },
    round(): boolean {
      return isServiceRoleMode();
    },
    flat(): boolean {
      return !isServiceRoleMode();
    },
  },
  methods: {
    openModal(): void {
      openModal(
        UserRolesModal, {
          parent: this,
          user: this.user,
        },
      );
    },
  },
});
